let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("HnCb7")).then(() => parcelRequire('h8b2X'));